import React from "react";
import { NextSeo } from "next-seo";
// import { defaultTitle, defaultDescription, defaultImages } from "../seoConfig";
import convertHTMLToPlainText from "../../../../utils/convertHTMLToPlainText";
import { BASE_URL } from "@src/settings";

function getTitle(plan) {
    // let title = `${
    //     plan.name
    // } build cost of KSh ${plan.cost.toLocaleString()} (${plan.house_type})`;

    let title = `${plan.house_type} house plan:`;
    !!plan.bedrooms && plan.bedrooms > 0
        ? (title = title + ` ${plan.bedrooms} bedroom,`)
        : null;
    !!plan.bathrooms && plan.bathrooms > 0
        ? (title = title + ` ${plan.bathrooms} bath,`)
        : null;
    title = title + ` build cost ${plan.cost.toLocaleString()} KSh,`;
    !!plan.minimum_plot_size
        ? (title = title + ` ${plan.minimum_plot_size} min plot size`)
        : null;

    title = title + ` - ${plan.plan_identifier}`;

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return capitalizeFirstLetter(title.replace(/\n/g, " "));
}

function getDescription(plan) {
    let description = convertHTMLToPlainText(plan.description).replace(
        /\n/g,
        " "
    );
    let title = `${plan.name} with ${plan.bedrooms} bedrooms, ${
        plan.bathrooms
    } bathrooms, a build cost of KSh ${plan.cost.toLocaleString()} , a minimum plot size of ${
        plan.minimum_plot_size
    }. (${plan.house_type})`;
    return `${description} - ${title}`;
}

function getImages(plan) {
    let planImages = [];

    // images generated during build
    plan.images &&
        plan.images.forEach((img) => {
            if (!!img.image && !!img.image.imageFileName) {
                planImages.push({
                    url: `https://www.inuua.net/images/tmp/planImages/${img.image.imageFileName}`,
                });
            }
        });

    // default images
    plan.images &&
        plan.images.forEach((img) => {
            if (!!img.image && !!img.image.file) {
                planImages.push({ url: img.image.file });
            }
        });

    // // floor plans
    // plan.floor_plans &&
    //     plan.floor_plans.forEach((flr_plan) => {
    //         if (!!flr_plan.image && !!flr_plan.image.file) {
    //             planImages.push({ url: flr_plan.image.file });
    //         }
    //     });

    const images = [];
    planImages.forEach((planImage) =>
        images.push(
            planImage.url.startsWith("/")
                ? {
                      url: `${BASE_URL}${planImage.url}`,
                  }
                : {
                      url: planImage.url,
                  }
        )
    );
    // console.log(planImages);
    // console.log(images);
    // console.log(images.join("\n"));
    return images;
}

export default function PlanDetailSEO({ plan }) {
    const title = getTitle(plan);
    const description = getDescription(plan);
    const images = getImages(plan);

    return (
        <>
            <NextSeo
                title={title}
                description={description}
                canonical={`https://www.inuua.net/plans/plan/${plan.slug}`}
                openGraph={{
                    type: "website",
                    locale: "en_GB",
                    url: `https://www.inuua.net/plans/plan/${plan.slug}`,
                    site_name: "Inuua Tujenge",
                    title: title,
                    description: description,
                    images: images,
                }}
            />
        </>
    );
}

/*
Plan detail

{
    "id": 154,
    "images": [
        {
            "id": 267,
            "image": {
                "id": 869,
                "title": "Rear Image",
                "file": "https://inuua-prod.s3.amazonaws.com/original_images/42111_Rear.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAXURR2KJDSDNH7JF6%2F20210615%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20210615T093428Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=b4b2ed2d60576d7290a593864f3957a2571a60f2814e71632cdeab286e82cbf5",
                "width": 2000,
                "height": 1250,
                "created_at": "2021-01-12T14:37:04.567265+03:00",
                "focal_point_x": null,
                "focal_point_y": null,
                "focal_point_width": null,
                "focal_point_height": null,
                "file_size": 3054187,
                "file_hash": "64c9e29f5bf8f827ae226fb1267a1e9d4ec94179",
                "collection": 1,
                "uploaded_by_user": 510
            },
            "sort_order": 0,
            "building_plan": 154
        },
    ],
    "product": {
        "url": "http://api.inuua.net/oscar_api/products/132/",
        "upc": "building-plan-154",
        "id": 132,
        "title": "4 Bedroom  Maisonette- ID 42111",
        "description": "",
        "structure": "standalone",
        "date_created": "2021-01-12T14:46:35.210485+03:00",
        "date_updated": "2021-01-20T11:55:49.930856+03:00",
        "recommended_products": [],
        "attributes": [],
        "categories": [],
        "product_class": "building-plans",
        "images": [],
        "price": "http://api.inuua.net/oscar_api/products/132/price/",
        "availability": "http://api.inuua.net/oscar_api/products/132/availability/",
        "stockrecords": "http://api.inuua.net/oscar_api/products/132/stockrecords/",
        "options": [],
        "children": []
    },
    "floor_plans": [
        {
            "id": 172,
            "image": {
                "id": 871,
                "title": "Ground floor",
                "file": "https://inuua-prod.s3.amazonaws.com/original_images/groundfloor.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAXURR2KJDSDNH7JF6%2F20210615%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20210615T093428Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=e1335c193ed32a7954dd86e980af83e9874914d2fb68c54e78b59a4a66804e25",
                "width": 2100,
                "height": 1500,
                "created_at": "2021-01-14T21:04:35.382663+03:00",
                "focal_point_x": null,
                "focal_point_y": null,
                "focal_point_width": null,
                "focal_point_height": null,
                "file_size": 534250,
                "file_hash": "27eec2efbd80f488b9066e514a04e585a22570ef",
                "collection": 1,
                "uploaded_by_user": 510
            },
            "sort_order": 0,
            "name": "Ground floor",
            "building_plan": 154
        },
        {
            "id": 173,
            "image": {
                "id": 872,
                "title": "First floor",
                "file": "https://inuua-prod.s3.amazonaws.com/original_images/first_floor.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAXURR2KJDSDNH7JF6%2F20210615%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20210615T093428Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=65c4834d440eb16955819cbdf160d57c780eb575207fb5f6b85c4a72c1518ade",
                "width": 2100,
                "height": 1500,
                "created_at": "2021-01-14T21:23:41.333438+03:00",
                "focal_point_x": null,
                "focal_point_y": null,
                "focal_point_width": null,
                "focal_point_height": null,
                "file_size": 313625,
                "file_hash": "68d6e0419a356c3a40e7a4bb04d07101885fe438",
                "collection": 1,
                "uploaded_by_user": 510
            },
            "sort_order": 1,
            "name": "First floor",
            "building_plan": 154
        }
    ],
    "stages": [
        {
            "id": 1451,
            "stage_name": "Excavations",
            "sort_order": 0,
            "phase": null,
            "material_cost": "0.00",
            "labour_cost": "18000.00",
            "short_description": "",
            "notes": "",
            "duration": "6.0",
            "materials": "[]",
            "labour": "[{\"type\": \"item\", \"value\": {\"name\": \"Excavations\", \"components\": [{\"labourer_type\": \"Casuals\", \"number_of_labourers\": 5, \"num_days\": 6, \"rate\": 600}]}, \"id\": \"41dc480c-984a-46e8-af58-892b3a5cf04a\"}]",
            "documents": "[]",
            "building_plan": 154,
            "descriptor": 21,
            "parent": null,
            "image": null
        }
    ],
    "name": "4 Bedroom  Maisonette- ID 42111",
    "slug": "4-bedroom-maisonette-id-42111",
    "plan_identifier": "42111",
    "is_public": true,
    "date_created": "2021-01-12T14:46:35.133033+03:00",
    "description": "<p>This a 4 bedroom all ensuite maisonette, suited to a 30 x 60 plot. The dining room has purposely been kept separate from the living area but it can be combined, and the various terraces allow for some expansion of rooms if required.</p>",
    "house_type": "maisonette",
    "bedrooms": 4,
    "bathrooms": 4,
    "floor_area": 158.0,
    "plot_area": 1.0,
    "width": "30.00",
    "length": "60.00",
    "plan_price": "20000.00",
    "cost": 5223899,
    "show_calculated_cost": true,
    "ratings_score": null,
    "minimum_plot_size": "30x60"
}
*/
